import React from 'react';
import { Box, List, ListItem, makeStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import { CustomTheme } from 'common/ui/interfaces';
import messages from '../../messages';

const useStyles = makeStyles((theme: CustomTheme) => ({
  caption: {
    paddingTop: '24px',
    paddingBottom: '16px',
  },
  link: {
    color: theme.palette.error.main,
    textDecoration: 'underline',
    fontSize: '1rem',
    lineHeight: '32px',
  },
  dateText: {
    fontSize: '1rem',
    paddingBottom: '16px',
  },
  descriptionText: {
    fontSize: '1rem',
  },
  list: {
    listStyleType: 'disc',
    padding: '0 0 0 16px',
  },
  listItem: {
    display: 'list-item',
    '&::marker': {
      content: '"• "',
    },
  },
  text: {
    fontSize: '1rem',
    lineHeight: '32px',
  },
  boldText: {
    fontWeight: 700,
  },
}));

const TermsOfService = () => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <Typography className={classes.dateText}>
        {intl.formatMessage(messages.lastUpdated)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.welcomeToPeakPayment)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.useOfTheWebsite)}
      </Typography>
      <Box mb={2}>
        <Typography className={classes.text}>
          <Typography component="span" className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.eligibility)}
          </Typography>
          &nbsp;
          {intl.formatMessage(messages.youMustBeAnEmployeeOrMemberOfAGym)}
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography className={classes.text}>
          <Typography component="span" className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.accountCreation)}
          </Typography>
          &nbsp;
          {intl.formatMessage(messages.youMayBeRequiredToCreateAnAccount)}
        </Typography>
      </Box>
      <Typography className={cx(classes.text, classes.boldText)}>
        {intl.formatMessage(messages.smsCommunications)}
      </Typography>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.consentAndOptOut)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.unsubscribingAndRejoining)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.messageFrequencyandSupport)}
            &nbsp;
            <Link className={classes.link} to="https://www.peakserve.com" target="_blank">
              https://www.peakserve.com
            </Link>
            {intl.formatMessage(messages.forPrivacyRelatedInquiries)}
            &nbsp;
            <Link
              className={classes.link}
              to="https://peakpayment.com/privacy-policy/"
              target="_blank"
            >
              https://peakpayment.com/privacy-policy/
            </Link>
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.carrierAndDataRates)}
          </Typography>
        </ListItem>
      </List>
      <Box mb={2}>
        <Typography className={classes.text}>
          <Typography component="span" className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.permittedUse)}
          </Typography>
          &nbsp;
          {intl.formatMessage(messages.permittedUsesOfTheWebsiteInclude)}
        </Typography>
      </Box>
      <Typography className={classes.text}>
        <Typography component="span" className={cx(classes.text, classes.boldText)}>
          {intl.formatMessage(messages.prohibitedUse)}
        </Typography>
        &nbsp;
        {intl.formatMessage(messages.youMayNotUseTheWebsiteTo)}
      </Typography>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.useTheWebsiteToImpersonate)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.interfereWithOrDisruptTheWebsite)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.useAnyDataMining)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.useTheWebsiteToTransmit)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.violateThePrivacyOfAnyThirdParty)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.useTheWebsiteToTransmit)}
          </Typography>
        </ListItem>
      </List>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.intellectualProperty)}
      </Typography>
      <Box mb={2}>
        <Typography className={classes.text}>
          <Typography component="span" className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.ownership)}
          </Typography>
          &nbsp;
          {intl.formatMessage(messages.theWebsiteAndItsEntireContents)}
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography className={classes.text}>
          <Typography component="span" className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.limitedLicense)}
          </Typography>
          &nbsp;
          {intl.formatMessage(messages.theseTermsPermitYouToUse)}
        </Typography>
        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Typography className={classes.text}>
              {intl.formatMessage(messages.yourComputerMayTemporarilyStoreCopies)}
            </Typography>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Typography className={classes.text}>
              {intl.formatMessage(messages.youMayStoreFilesThatAreAutomaticallyCached)}
            </Typography>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Typography className={classes.text}>
              {intl.formatMessage(messages.youMayPrintOrDownloadOneCopyOfAReasonable)}
            </Typography>
          </ListItem>
        </List>
      </Box>
      <Box mb={2}>
        <Typography className={classes.text}>
          <Typography component="span" className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.noModification)}
          </Typography>
          &nbsp;
          {intl.formatMessage(messages.youMustNotModifyCopiesOfAnyMaterials)}
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography className={classes.text}>
          <Typography component="span" className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.noCommercialUse)}
          </Typography>
          &nbsp;
          {intl.formatMessage(messages.youMustNotUseAnyIllustrations)}
        </Typography>
      </Box>
      <Typography className={classes.text}>
        <Typography component="span" className={cx(classes.text, classes.boldText)}>
          {intl.formatMessage(messages.reservationOfRights)}
        </Typography>
        &nbsp;
        {intl.formatMessage(messages.allRightsNotExpresslyGranted)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.disclaimer)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.theWebsiteAndAllContentAndServices)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.limitationOfLiability)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.inNoEventWillWe)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.indemnification)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.youAgreeToDefend)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.termination)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.weMayTerminateYourAccess)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.governingLaw)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.theseTermsAndAnyDispute)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.disputeResolution)}
      </Typography>
      <Typography className={classes.text}>{intl.formatMessage(messages.anyLegalSuit)}</Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.waiverAndSeverability)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.noWaiverByUsOfAnyTermOrCondition)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.entireAgreement)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.theseTermsConstituteTheSole)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.changesToTerms)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.weReserveTheRight)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.termsOfServiceContactUs)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.termsOfServiceIfYouHaveAnyQuestions)}
      </Typography>
      <Typography className={classes.text}>
        <Link className={classes.link} to="https://www.peakserve.com" target="_blank">
          https://www.peakserve.com
        </Link>
        .
      </Typography>
    </>
  );
};

export default TermsOfService;
